import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, onSnapshot, updateDoc, increment } from 'firebase/firestore';
import styles from './Viewer.module.css';

const MusicViewer = () => {
    const logoUrl = "/logo.png"; 

    const { id } = useParams();
    const [song, setSong] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isBlurred, setIsBlurred] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    useEffect(() => {
        if (!id) return;
        const docRef = doc(db, "secure_shares", id);
        const unsubscribe = onSnapshot(docRef, (snap) => {
            if (snap.exists()) {
                setSong(snap.data());
                setError(null);
            } else {
                setError("Vault link invalid or expired.");
            }
            setLoading(false);
        }, (err) => {
            setError("Security Protocol Denied access.");
            setLoading(false);
        });

        const handleBlur = () => setIsBlurred(true);
        const handleFocus = () => setIsBlurred(false);
        window.addEventListener('blur', handleBlur);
        window.addEventListener('focus', handleFocus);
        window.addEventListener('contextmenu', (e) => e.preventDefault());

        return () => {
            unsubscribe();
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('focus', handleFocus);
        };
    }, [id]);

    const handlePlay = async () => {
        if (song.plays >= 2) {
            audioRef.current.pause();
            return;
        }
        setIsPlaying(true);
        const docRef = doc(db, "secure_shares", id);
        await updateDoc(docRef, { plays: increment(1) });
    };

    if (loading) return <div className={styles.loadingScreen}><div className={styles.spinner}></div><p>Establishing Secure Connection...</p></div>;
    if (error) return <div className={styles.errorContainer}><div className={styles.errorBox}>⚠️ {error}</div></div>;

    return (
        <div className={`${styles.viewerPage} ${isBlurred ? styles.blurred : ''}`}>
            {/* Animated Background Elements */}
            <div className={styles.bgGlow1}></div>
            <div className={styles.bgGlow2}></div>

            <div className={styles.playerCard}>
                <header className={styles.cardHeader}>
                    <img src={logoUrl} alt="Ananta Infotech" className={styles.logo} />
                    <div className={styles.securityStatus}>
                        <span className={styles.pulseDot}></span>
                        SECURE SESSION ACTIVE
                    </div>
                </header>

                <main className={styles.cardContent}>
                    <div className={styles.audioVisualizer}>
                        <div className={`${styles.bar} ${isPlaying ? styles.animate : ''}`}></div>
                        <div className={`${styles.bar} ${isPlaying ? styles.animate : ''}`}></div>
                        <div className={`${styles.bar} ${isPlaying ? styles.animate : ''}`}></div>
                        <div className={`${styles.bar} ${isPlaying ? styles.animate : ''}`}></div>
                        <div className={`${styles.bar} ${isPlaying ? styles.animate : ''}`}></div>
                    </div>

                    <h2 className={styles.songTitle}>{song.songName || "Secure Track"}</h2>
                    
                    {song.plays < 2 ? (
                        <div className={styles.playerSection}>
                            <div className={styles.playCounter}>
                                <span>Access Remaining</span>
                                <strong>{2 - song.plays} / 2</strong>
                            </div>
                            
                            <audio 
                                ref={audioRef}
                                src={song.audioUrl} 
                                controls 
                                controlsList="nodownload" 
                                onPlay={handlePlay}
                                onPause={() => setIsPlaying(false)}
                                className={styles.audioTag}
                            />
                        </div>
                    ) : (
                        <div className={styles.expiredOverlay}>
                            <div className={styles.lockIcon}>🔒</div>
                            <h3>ACCESS REVOKED</h3>
                            <p>Playback limit reached for this session.</p>
                        </div>
                    )}
                </main>
                
                <footer className={styles.cardFooter}>
                    <p>Protected by <strong>Ananta Infotech</strong> Security Protocol</p>
                    <small>Encryption: AES-256 | Anti-Capture: ENABLED</small>
                </footer>
            </div>
        </div>
    );
};

export default MusicViewer;